import React from 'react';
import { IMAGES } from "../../../assets";
import "./Loader.css";

const Loader = () => {
    return (    
      <div className="spinner"></div>
//     <img
    
//     alt="Loading…"
//     src={IMAGES.loader}
// />
  )
}

export default Loader